/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Harden_Output6Inputs */

const en_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live store listing`)
};

const ar_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة متجر حية`)
};

const bn_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ স্টোর লিস্টিং`)
};

const de_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Store-Eintrag`)
};

const es_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficha de Play Store activa`)
};

const fr_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiche Play Store en direct`)
};

const pt_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listagem da loja ativa`)
};

const zh_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时商店列表`)
};

const tr_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı mağaza girişi`)
};

const ru_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актуальная страница магазина`)
};

const pl_svc_mobile_app_development_harden_output6 = /** @type {(inputs: Svc_Mobile_App_Development_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualne informacje o sklepie`)
};

/**
* | output |
* | --- |
* | "Live store listing" |
*
* @param {Svc_Mobile_App_Development_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_harden_output6 = /** @type {((inputs?: Svc_Mobile_App_Development_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_harden_output6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_harden_output6(inputs)
	return en_svc_mobile_app_development_harden_output6(inputs)
});
export { svc_mobile_app_development_harden_output6 as "svc_mobile-app-development_HARDEN_output" }